import React, { useCallback, useState } from "react";
import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";
import { Grid, makeStyles, Button, Paper, Typography } from "@material-ui/core";
import { MailOutline, GetApp } from "@material-ui/icons";
import { emptyString } from "constants/defaultValues";
import SendOrDownloadProduct from "./SendOrDownloadProduct";

const useStyles = makeStyles((_theme) => ({
  footerInfo: { backgroundColor: "#d3d3d3", padding: "15px", margin: "5px 0px 5px 0px" },
}));

function FooterInfo({ quoteProducts, currencyCode, showAmountsWithVAT, onDownloadProducts, onSendProductsOnEmail }) {
  const { t } = useTranslation();
  const classes = useStyles();

  const [openViewDialog, setOpenViewDialog] = useState(false);
  const [openViewDialogType, setOpenViewDialogType] = useState(emptyString);

  const handleClick = useCallback((event) => {
    const type = event.currentTarget.id;
    switch (type) {
      case "product_sendViaEmail":
        setOpenViewDialogType(type);
        setOpenViewDialog(true);
        break;
      case "product_download":
        setOpenViewDialogType(type);
        setOpenViewDialog(true);
        break;
    }
  }, []);

  return (
    <Paper className={classes.footerInfo}>
      <Grid container direction="row" alignItems="center">
        <Grid item xs={6}>
          <Typography variant="h5">{t("Product.DownloadQuotes")}</Typography>
        </Grid>
        <Grid item container xs={6} justifyContent="flex-end">
          <Grid item>
            <Button id="product_sendViaEmail" onClick={handleClick} startIcon={<MailOutline />}>
              {t("Product.SendViaEMAIL")}
            </Button>
          </Grid>
          <Grid item>
            <Button id="product_download" onClick={handleClick} startIcon={<GetApp />}>
              {t("Product.Download")}
            </Button>
          </Grid>
          <Grid item>
            {openViewDialog && (
              <SendOrDownloadProduct
                openViewDialogType={openViewDialogType}
                openViewDialog={openViewDialog}
                setOpenViewDialog={setOpenViewDialog}
                quoteProducts={quoteProducts}
                currencyCode={currencyCode}
                showAmountsWithVAT={showAmountsWithVAT}
                onDownloadProducts={onDownloadProducts}
                onSendProductsOnEmail={onSendProductsOnEmail}
              />
            )}
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
}

FooterInfo.propTypes = {
  quoteProducts: PropTypes.array.isRequired,
  currencyCode: PropTypes.string.isRequired,
  showAmountsWithVAT: PropTypes.bool.isRequired,
  onDownloadProducts: PropTypes.func.isRequired,
  onSendProductsOnEmail: PropTypes.func.isRequired,
};

export default FooterInfo;
